import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaHandHoldingHeart } from "react-icons/fa";
import "./Navbar.css";
import logo_transparent from "../../Asset/Icons/logo_transparent.png";

const Navbar = () => {

  const { t } = useTranslation();

  const [activeDropdown, setActiveDropdown] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleDropdown = (name) => {
    setActiveDropdown(activeDropdown === name ? null : name);
  };

  const closeDropdown = () => {
    setActiveDropdown(null);
    setMenuOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setActiveDropdown(null);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header className="navbar">

      <div className="navbar-container">

        {/* BRAND */}
        <NavLink to="/" className="navbar-brand" onClick={closeDropdown}>

          <img
            src={logo_transparent}
            alt="MAANAVTA HITAAY SEVA CHATRA"
            className="brand-logo"
          />

                <div className="brand-text">
              <span className="brand-title">
                {t('brand.title')}
              </span>
              <h6 className="brand-old">{t('brand.location')}</h6>
              <span className="brand-project">
                {t('brand.subtitle')}
              </span>
            </div>

        </NavLink>

        {/* HAMBURGER */}
        <div
          className={`hamburger ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* NAV MENU */}
        <nav className={`navbar-menu ${menuOpen ? "active" : ""}`}>

          <NavLink to="/" className="nav-link" onClick={closeDropdown}>
            {t("nav_home")}
          </NavLink>

          {/* ABOUT */}
          <div className="dropdown">

            <button
              className={`dropdown-btn ${activeDropdown === "about" ? "active" : ""}`}
              onClick={() => toggleDropdown("about")}
              type="button"
            >
              {t("nav_about")} <span className="dropdown-arrow">▾</span>
            </button>

            <div className={`dropdown-menu ${activeDropdown === "about" ? "show" : ""}`}>

             <NavLink to="/KnowAboutOrg" onClick={closeDropdown}>{t('nav.about.org')}</NavLink>
      <NavLink to="/VisionMission" onClick={closeDropdown}>{t('nav.about.vision')}</NavLink>
      <NavLink to="/GovBody" onClick={closeDropdown}>{t('nav.about.team')}</NavLink>
      <NavLink to="/RewardsRecognization" onClick={closeDropdown}>{t('nav.about.awards')}</NavLink>
      <NavLink to="/DocumentsRequired" onClick={closeDropdown}>{t('nav.about.docs')}</NavLink>
            </div>

          </div>

          {/* GALLERY */}
          <div className="dropdown">

            <button
              className={`dropdown-btn ${activeDropdown === "gallery" ? "active" : ""}`}
              onClick={() => toggleDropdown("gallery")}
              type="button"
            >
              {t("nav_galleryy")} <span className="dropdown-arrow">▾</span>
            </button>

            <div className={`dropdown-menu ${activeDropdown === "gallery" ? "show" : ""}`}>

             <NavLink to="/RewardsRecognization" onClick={closeDropdown}>{t('nav.media.awards_rec')}</NavLink>
      <NavLink to="/GuestVisitActivities" onClick={closeDropdown}>{t('nav.media.activities')}</NavLink>
      <NavLink to="/MedicallSupport" onClick={closeDropdown}>{t('nav.media.medical')}</NavLink>
      <NavLink to="/News" onClick={closeDropdown}>{t('nav.media.news')}</NavLink>
      <NavLink to="/Videos" onClick={closeDropdown}>{t('nav.media.videos')}</NavLink>

            </div>

          </div>

          {/* SERVICES */}
          <div className="dropdown">

            <button
              className={`dropdown-btn ${activeDropdown === "services" ? "active" : ""}`}
              onClick={() => toggleDropdown("services")}
              type="button"
            >
              {t("nav_services")} <span className="dropdown-arrow">▾</span>
            </button>

            <div className={`dropdown-menu ${activeDropdown === "services" ? "show" : ""}`}>

             <NavLink to="/AssistedLiving" onClick={closeDropdown}>{t('nav.services.assisted')}</NavLink>
      <NavLink to="/CriticalPatientSupport" onClick={closeDropdown}>{t('nav.services.critical')}</NavLink>
      <NavLink to="/DementiaCare" onClick={closeDropdown}>{t('nav.services.dementia')}</NavLink>
      <NavLink to="/PalliativeCare" onClick={closeDropdown}>{t('nav.services.palliative')}</NavLink>
      <NavLink to="/MedicalSupport" onClick={closeDropdown}>{t('nav.services.medical')}</NavLink>
      <NavLink to="/MentalHealth" onClick={closeDropdown}>{t('nav.services.mental')}</NavLink>
      <NavLink to="/RecoveryRehab" onClick={closeDropdown}>{t('nav.services.rehab')}</NavLink>
      <NavLink to="/FamilyConsults" onClick={closeDropdown}>{t('nav.services.consults')}</NavLink>
      <NavLink to="/MealsNutrition" onClick={closeDropdown}>{t('nav.services.meals')}</NavLink>

            </div>

          </div>

          <NavLink to="/Contactus" className="nav-link" onClick={closeDropdown}>
            {t("nav_contact")}
          </NavLink>

          <NavLink to="/FAQ" className="nav-link" onClick={closeDropdown}>
            {t("nav_faq")}
          </NavLink>

          {/* DONATE BUTTON */}
          <NavLink to="/Donate" className="donate-btn" onClick={closeDropdown}>
            <FaHandHoldingHeart className="donate-icon"/>
            {t("nav_donate")}
          </NavLink>

        </nav>

      </div>

    </header>
  );
};

export default Navbar;